/**
 * Unauthorized / Forbidden Page — 403
 *
 * Shown when a user tries to access a route they don't have
 * the required role/permission for.
 */

import { useNavigate, Link } from 'react-router-dom';
import { ShieldAlert, ArrowLeft, Home, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuthStore } from '../state_management_and_stores/auth.store';

export default function UnauthorizedPage() {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="text-center max-w-md">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10 mb-6">
          <ShieldAlert className="h-8 w-8 text-destructive" />
        </div>
        <h1 className="text-3xl font-bold text-foreground mb-2">
          Access Denied
        </h1>
        <p className="text-muted-foreground mb-2">
          You don't have permission to view this page.
        </p>
        {user?.email && (
          <p className="text-sm text-muted-foreground mb-6">
            Signed in as <span className="font-medium text-foreground">{user.email}</span>
          </p>
        )}

        <div className="rounded-lg border border-blue-500/20 bg-blue-500/5 p-3 mb-6">
          <p className="text-sm text-blue-600 dark:text-blue-400">
            Need access? Contact your organization administrator to request the
            appropriate role.
          </p>
        </div>

        <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
          <Button onClick={() => navigate(-1)} variant="default">
            <ArrowLeft className="mr-1 h-4 w-4" />
            Go Back
          </Button>
          <Link to="/dashboard">
            <Button variant="outline" className="w-full sm:w-auto">
              <Home className="mr-1 h-4 w-4" />
              Dashboard
            </Button>
          </Link>
          <Link to="/support">
            <Button variant="ghost" className="w-full sm:w-auto">
              <Mail className="mr-1 h-4 w-4" />
              Support
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
